import { useState, useEffect } from 'react';
export function useTheme() {
    const [theme, setTheme] = useState(() => {
        const saved = localStorage.getItem('apex_theme');
        return saved ?? 'dark';
    });
    useEffect(() => {
        const root = document.documentElement;
        if (theme === 'dark') {
            root.classList.add('dark');
        }
        else {
            root.classList.remove('dark');
        }
        localStorage.setItem('apex_theme', theme);
    }, [theme]);
    const toggle = () => setTheme(t => t === 'dark' ? 'light' : 'dark');
    return { theme, toggle };
}
